'use strict';

var _ = require('lodash');
var CommentsService = function CommentsService(restangular, configurationService, momentService) {
  var restangularNotesEndpoint = restangular.one('notes');
  function formatKey(entity, key) {
    return _.chain(entity).pick(key).reduce(function (result, current, key) {
      if (momentService.isMoment(current)) {
        result[key] = current.toISOString();
      } else {
        result[key] = current.toString();
      }
      return result;
    }, {}).value();
  }
  function parseNoteTimestamp(note) {
    note.date = momentService.of(note.timestamp, momentService.FIELD.CREATED_DATE);
  }
  function parseNotes(notes) {
    for (var i = 0, length = notes.length; i < length; i++) {
      parseNoteTimestamp(notes[i]);
    }
  }
  function save(entity, key, comment, level) {
    var keyData = formatKey(entity, key);
    var data = {
      level: level,
      key: keyData,
      notes: [{
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP).toISOString(),
        text: comment,
        userId: configurationService.getUserId()
      }]
    };
    return restangularNotesEndpoint.customPUT(data).then(function (data) {
      parseNoteTimestamp(data.notes[0]);
      return data.notes[0];
    });
  }
  function get(entity, key) {
    var params = formatKey(entity, key);
    return restangularNotesEndpoint.get(params).then(function (data) {
      parseNotes(data.notes || []);
      return data.notes || [];
    });
  }
  return {
    save: save,
    get: get
  };
};
CommentsService.$inject = ['Restangular', 'ConfigurationService', 'MomentService'];
module.exports = CommentsService;